import React, { useEffect } from 'react'
import {Link} from "react-router-dom"
import AOS from "aos";
import "aos/dist/aos.css";
function Register() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  const handleLinkClick = () => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };
  return (
    <div className="w-full sectionlayout bg-[#F3F3F3] overflow-hidden pt-12" id='registration'>
      <div className=" flex justify-center items-center  min-h-[90vh] 2xl:min-h-[55vh]  relative pt-[3rem] "

      >
        <div className='md:w-[80%] lg:w-[73%] 2xl:w-[63%] w-full '>
          <h2
            style={{ fontSize: "clamp(30px,3vw,55px)" }}
            className="text-[#3E4E41] uppercase py-8  text-center font-bold"
            data-aos="fade-up"
          >
            Register Yourself now
          </h2>
          <p className='text-[#333333]  font-medium text-center' style={{ fontSize: "clamp(22px,1.4vw,30px)" }} data-aos="fade-up">
            Join our comprehensive Shopify course designed to turn beginners into experts! Whether you're launching your first store or looking to scale your existing business, this course is for you.
          </p>
          <div className='w-full flex justify-center items-center'>
            <button className="px-[17px]  my-8 py-[7px] poppins border-[2px] bg-[#B38E5D] shadow-md transition-all duration-300 ease-in-out text-white hover:bg-transparent hover:text-[#B38E5D] border-[#B38E5D] rounded-[10px] font-semibold">
              <Link to="/registration" onClick={handleLinkClick}>
                Register Now
              </Link>
            </button>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Register;
